import { nsSelector } from '../../../../../utils/redux';

const categories = nsSelector('categories');

export const allCategoriesList = categories('all');
export const categoriesList = categories('list');
export const categoriesItem = categories('item');
